import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_SIGN_UP_COMPLETED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_SIGN_UP_COMPLETED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SIGN_UP_COMPLETED_SCHEMA);

export class SignUpCompletedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.sign_up_completed;
  }

  get properties() {
    return this.toJS();
  }
}
